<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Slider"
    }
</script>

<style scoped>

</style>